import api from '@/api/axios';

export interface Institution {
  displayName: string;
  value: string;
}

export const getInstitutions = async (): Promise<Institution[]> => {
  const { data } = await api.get(`/api/institutions`);
  return data;
};
